/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import classnames from 'classnames';
import { Bubble, Card, Icon } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';
import Loading from '@gp/components/Loading';
import NoData from '@gp/components/NoData';
import LinkJump from '@gp/components/LinkJump';

import './index.scss';
import { ORDER_METRICS_CONSOLE } from '@intelligence/components/ExportTable/instance/const';

const getLoading = (loadingType: string): React.ReactElement => {
  switch (loadingType) {
    case 'round':
      return <Loading loading style={{ height: 200 }} />;

    default:
      return <Loading loading style={{ height: 200 }} />;
  }
};

export default function CardSlot(props: any) {
  // children:  插入内容
  // title: 标题这里字符串和dom元素都可以
  // activeTab: 当前选择tab
  // isEyes: 是否展示右侧的眼睛查看icon  默认flase不展示，  true的话展示
  // isDownload: 是否展示右侧的下载  默认flase不展示，  true的话展示
  // iconList: 右边的icon 不传的话只显示下载
  // isAction: 如果需要左边右边箭头可以点击去的 true ，默认flase， 可以不传
  // getChange：右边按钮点击事件
  // getEyes: 显示不显示事件按钮
  // onDownload： 下载事件按钮
  // className： 传的类名
  const {
    style,
    className,
    children,
    title,
    activeTab,
    isEyes,
    isDownload,
    iconList,
    isAction,
    getChange,
    getEyes,
    onDownload,
    getDetails,
    rightDom,
    leftDom,
    isShowRightDom,
    visibleRightOperation = true,
    downloadLoading,
    // 新加TriggerViewCard组件
    loading,
    loadingType,
    isNoData,
    noDataText,
  } = props;

  const [isShow, setIsShow] = useState(false);

  const getCardTitle = () => {
    if (!isAction) return title;
    if (leftDom) return leftDom;

    return (
      <LinkJump style={{ display: 'inline-block' }} url={getDetails(false)}>
        <div
          className={classnames({
            'dbg-card-slot-title-hover': isAction,
            'dbg-card-slot-title': !isAction,
          })}
          onClick={(e) => getDetails(true, e)}
        >
          <span>{title}</span>
          <SvgIcon className="dbg-card-slot-icon" type="arrow-right" />
        </div>
      </LinkJump>
    );
  };

  const getCardOperation = () => {
    if (!visibleRightOperation) return null;
    if (rightDom) return rightDom;

    return (
      <div className={classnames('dbg-card-slot-flex', isShowRightDom)}>
        {!!isEyes && (
          <Bubble dark content={isShow ? '不显示' : '显示'}>
            <i
              className="dbg-card-slot-item"
              onClick={() => {
                setIsShow(!isShow);
                getEyes(isShow);
              }}
            >
              <SvgIcon
                className="dbg-card-slot-charicon"
                type={isShow ? 'eyes-closed' : 'open-eyes'}
              />
            </i>
          </Bubble>
        )}
        {iconList?.map((iconItem: any, iconIndex: any) => {
          // 注意这里bubbleVisible的默认值设置为undefined，是为了让Bubble组件能以非受控的模式 实现鼠标hover出现气泡
          const {
            isText = false,
            bubbleOverlayStyle,
            bubbleFlipped = true,
            bubbleEscapeWithReference = false,
            bubbleVisible = undefined,
            bubblePlacement = 'top',
            bubbleArrowPointAtCenter = false,
            icon,
            context,
          } = iconItem || {};
          const isIconActive = icon === activeTab;

          if (isText)
            return (
              <i
                key={iconIndex}
                className="dbg-card-slot-text"
                onClick={() => {
                  getChange(icon);
                }}
              >
                {context}
              </i>
            );

          return (
            <Bubble
              key={`${iconIndex}_${bubbleVisible}`}
              overlayStyle={bubbleOverlayStyle}
              className="dbg-bubble-max-width"
              dark
              flipped={bubbleFlipped}
              escapeWithReference={bubbleEscapeWithReference}
              visible={bubbleVisible}
              placement={bubblePlacement}
              arrowPointAtCenter={bubbleArrowPointAtCenter}
              content={context}
            >
              <i
                className={classnames({
                  'dbg-card-slot-action': isIconActive,
                  'dbg-card-slot-item': !isIconActive,
                })}
                onClick={() => {
                  getChange(icon);
                }}
              >
                <SvgIcon className="dbg-card-slot-charicon" type={icon} />
              </i>
            </Bubble>
          );
        })}
        {!!isDownload && (
          <Bubble dark>
            {downloadLoading ? (
              <i className="dbg-card-slot-char">
                <Icon type="loading" />
              </i>
            ) : (
              <i className="dbg-card-slot-char" onClick={onDownload}>
                <SvgIcon className="dbg-card-slot-charicon" type="download" />
              </i>
            )}
          </Bubble>
        )}
      </div>
    );
  };

  return (
    <Card style={style} className={classnames('dbg-card-slot', className)}>
      {!title && !leftDom && <Card.Body>{children}</Card.Body>}
      {!!title && (
        <Card.Body title={getCardTitle()} operation={getCardOperation()}>
          {loading ? (
            getLoading(loadingType)
          ) : isNoData ? (
            <NoData constomStyle={{ fontSize: 14 }} height={200} text={noDataText} />
          ) : children ? (
            children
          ) : (
            <div className="line-text">图表占位</div>
          )}
        </Card.Body>
      )}
    </Card>
  );
}
